import { ROUTES } from './constants';
import { client, remote } from '../../store/operations';
import { networkOnly } from '../../store/utils';

/**
 * When given the store, returns a function that accepts id and movingCompany
 * If there is a movingCompany we are in single company flow (returns {})
 * Else, in the multi company flow get the moveIqMove based on the id
 * In order to get the moveDetails to pass into moveIqSurveyAvailability
 *
 * @param {ApolloClient.query} query The query function given by apollo client
 */
const getCompaniesForAnalytics = query => ({ id, movingCompany }) =>
  movingCompany
    ? Promise.resolve({})
    : query(client.moveIqMove(id))
        .then(({ data: { moveIqMove } }) =>
          query(
            networkOnly(
              remote.moveIqSurveyAvailability({
                fromAddress: moveIqMove.fromAddressDetails.address,
                toAddress: moveIqMove.toAddressDetails.address,
                date: moveIqMove.moveDate,
              })
            )
          )
        )
        .then(({ data: { moveIqSurveyAvailability = [] } }) => ({
          companies: moveIqSurveyAvailability,
        }));

const getMoveData = query =>
  query(client.currentMove()).then(
    ({
      data: {
        CurrentMove: { id, movingCompany },
      },
    }) => ({
      id,
      movingCompany,
    })
  );

const getAnalyticsPropertiesWithCompanies = ({ query }) => {
  const moveData = getMoveData(query);
  return moveData.then(getCompaniesForAnalytics(query)).then(companies => ({
    ...companies,
  }));
};

// Note: Local, Large Home, and Out of Service
// no longer need to be configured in this route
// Because they have a different workflow now
// TODO: Clean up this code
export const ANALYTICS_PROPERTIES = {
  [ROUTES.local]: {},
  [ROUTES.largeHome]: {},
  [ROUTES.outOfServiceArea]: {},
  [ROUTES.longDistance]: getAnalyticsPropertiesWithCompanies,
};
